import React, { useEffect, useState } from 'react'
import EditSwimlaneComponent from '../swimlane/EditSwimlane'
import ControlSwimlaneComponent, {
    ISwimlaneView,
} from '../swimlane/ControlSwimlane'
import {
    addSwimlane,
    CREATE_SWIMLANE,
    isSwimlaneCreateAction,
    moveSwimlane,
} from '../../flux/swimlanes/SwimlaneActions'
import Dispatcher, { IAction } from '../../flux/Dispatcher'
import MoveSwimlaneComponent from '../swimlane/MoveSwimlane'
import './ControlBoardSwimlanes.scss'

/**
 * Properties required by the ControlBoardSwimlanes component
 */
export interface IControlBoardSwimlanesProps {
    boardId: number
    swimlaneIds: number[]
}

/**
 * Renders swimlanes belonging to a board.
 * Also toggles the add mode on and off
 * @param props Board Id, Swimlane Ids
 */
function ControlBoardSwimlanesComponent(props: IControlBoardSwimlanesProps) {
    const _swimlane: ISwimlaneView = {
        id: -1,
        order: -1,
        name: '',
        taskIds: [],
    }
    const [isAdd, setAdd] = useState(false)
    const [move, setMove] = useState({ isMove: false, swimlaneId: -1 })

    function handleCancel() {
        setAdd(false)
    }

    function handleSave(swimlane: ISwimlaneView) {
        addSwimlane(props.boardId, swimlane)
        setAdd(false)
    }

    /**
     * Handles a move swimlane request coming from ControlSwimlane
     * @param boardId board swimlane belongs to
     * @param swimlaneId swimlane to move
     */
    function handleMove(boardId: number, swimlaneId: number) {
        setMove({ isMove: true, swimlaneId })
    }

    /**
     * Handles move swimlane left command
     */
    function handleLeft() {
        const index = props.swimlaneIds.findIndex(
            (id) => id === move.swimlaneId
        )
        moveSwimlane(
            props.boardId,
            move.swimlaneId,
            props.boardId,
            props.swimlaneIds[index - 1]
        )
    }

    /**
     * Handles move swimlane right command
     */
    function handleRight() {
        const index = props.swimlaneIds.findIndex(
            (id) => id === move.swimlaneId
        )
        moveSwimlane(
            props.boardId,
            move.swimlaneId,
            props.boardId,
            props.swimlaneIds[index + 1]
        )
    }

    /**
     * Handles move swimlane done command
     */
    function handleDone() {
        setMove({ isMove: false, swimlaneId: -1 })
    }

    useEffect(() => {
        /**
         * Determines if action is ISwimlaneCreate action
         * If so determines if it's for this board.
         * If so then toggles the state
         * @param action Action
         */
        function handleAddSwimlaneAction(action: IAction) {
            if (!isSwimlaneCreateAction(action)) return false
            if (!(action.payload.boardId === props.boardId)) return false
            if (action.actionType !== CREATE_SWIMLANE) return false
            setAdd(true)
        }

        const handle = Dispatcher.register(handleAddSwimlaneAction)
        return () => {
            Dispatcher.unregister(handle)
        }
    }, [isAdd, props.boardId])

    return (
        <>
            {props.swimlaneIds.map((swimlane, index, array) => (
                <div className="col position-relative" key={swimlane}>
                    <ControlSwimlaneComponent
                        boardId={props.boardId}
                        swimlaneId={swimlane}
                        canMove={array.length > 1}
                        onMove={handleMove}
                    />
                    {move.isMove && swimlane === move.swimlaneId && (
                        <div className="position-absolute swimlane-overlay">
                            <MoveSwimlaneComponent
                                showLeft={index !== 0}
                                showRight={index !== array.length - 1}
                                onLeft={handleLeft}
                                onRight={handleRight}
                                onDone={handleDone}
                            />
                        </div>
                    )}
                </div>
            ))}
            {isAdd && (
                <div className="col">
                    <EditSwimlaneComponent
                        swimlane={_swimlane}
                        onCancel={handleCancel}
                        onSave={handleSave}
                    />
                </div>
            )}
        </>
    )
}

export default ControlBoardSwimlanesComponent
